import { Button, SpriteFrame, _decorator } from 'cc';

const { ccclass, property } = _decorator;

@ccclass('ButtonSpriteSet')
export default class ButtonSpriteSet {
    @property(SpriteFrame)
    normal: SpriteFrame = null;
    @property(SpriteFrame)
    pressed: SpriteFrame = null;
    @property(SpriteFrame)
    hover: SpriteFrame = null;
    @property(SpriteFrame)
    disabled: SpriteFrame = null;

    public apply(button: Button) {
        button.normalSprite = this.normal;
        button.pressedSprite = this.pressed ?? this.normal;
        button.hoverSprite = this.hover ?? this.normal;
        button.disabledSprite = this.disabled ?? this.normal;
        button.updateState();
    }
}
